import { useMemo } from 'react'

import classNames from 'classnames'
import { useParams } from 'react-router-dom'

import { useConfiguration } from '@app/hooks'
import { getAppUrl, getBackUrl } from '@app/utils'

import { Icon } from '@lib/components'

import styles from './styles.module.scss'

export const AppHeader = () => {
  const { conversationId } = useParams()

  const configuration = useConfiguration()

  const baseUrl = getAppUrl(configuration, '')
  const backUrl = useMemo(() => getBackUrl(configuration), [configuration])

  const headerClassName = useMemo(
    () =>
      classNames(styles.header, {
        [styles.hide]: Boolean(conversationId),
      }),
    [conversationId]
  )

  return (
    <div className={headerClassName}>
      <a href={backUrl} className={styles.back}>
        <Icon path="icons/icon-back" />
      </a>
      <a href={baseUrl} className={styles.logo}>
        <Icon path="properstar-logo" />
      </a>
    </div>
  )
}
